import { render, staticRenderFns } from "./ModalCotizarAfiliacion.vue?vue&type=template&id=83000d7e&scoped=true&"
import script from "./ModalCotizarAfiliacion.vue?vue&type=script&lang=js&"
export * from "./ModalCotizarAfiliacion.vue?vue&type=script&lang=js&"
import style0 from "./ModalCotizarAfiliacion.vue?vue&type=style&index=0&id=83000d7e&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "83000d7e",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VBtn } from 'vuetify/lib/components/VBtn';
import { VCard } from 'vuetify/lib/components/VCard';
import { VCardText } from 'vuetify/lib/components/VCard';
import { VCol } from 'vuetify/lib/components/VGrid';
import { VDivider } from 'vuetify/lib/components/VDivider';
import { VRow } from 'vuetify/lib/components/VGrid';
import { VSimpleCheckbox } from 'vuetify/lib/components/VCheckbox';
installComponents(component, {VBtn,VCard,VCardText,VCol,VDivider,VRow,VSimpleCheckbox})
